import axios from "axios";
import Models from "../data/models.json";

class toyotaServices {
  constructor() {
    this.service = axios.create({
      // baseURL: process.env.REACT_APP_SERVICE_TOYOTA_URL,
      baseURL: process.env.REACT_APP_SERVICE_ADESIS_URL,
    });
  }

  getAllCarsInfo = async () => {
    return (await this.service.get('/calcMant/GetVehicleModelConfiguration')).data.Data;
  
    // return this.service
    //   .get("/vehicleModelConfiguration?brandname=lexus")
    //   .then(response => {
    //       response.data.forEach((vehicle)=>{
    //       let model = this.getModelByRangeCode(vehicle.rangeCode)

    //       vehicle.lst=vehicle.lst.filter(el=>{
    //         // return model? el.year<=model.years[1] && el.year>=model.years[0]:true
    //         return model? el.year<=model.years[1] && el.year>=model.years[0]:true
           
    //       })
    //     })
    //    console.log(JSON.stringify(response.data))
    //     return response
    //   }
    //     )
        
    //   .catch(e => console.log(e));
  };

  getModelByRangeCode(rangeCode){
    return Models.find(model=>
      model.rangeCode==rangeCode
    )
  }

  getCarByRegistration = plate => {
    return this.service
      .get(`/vehicle?registrationPlate=${plate}`)
      .then(response => response)
      .catch(e => console.log(e));
  };
}

export default toyotaServices;


// "DealershipName":"A.E. LLORENTE S.A.",
// "DealershipId":"1199-02",
// "DealershipAddress":"Av. Doctor Federico Rubio y Gali, 62",
// "DealershipZipCode":"28039",
// "DealershipCity":"MADRID",
// "Result":0,
// "ErrorMessage":null,
// "AvailableDateTime":[],
// "Longitude":" -3.7105712999999696",
// "Latitude":"40.4525674",
// "CodigoQuiter":null,
// "bMecanica":true,
// "bChapa":false,
// "bRepuestos":true,
// "bCitaPrevia":true,
